<app-model
  [dimensions]="{ width: 620, height: 750 }"
  [id]="sidebarName"
  [hasBackBtn]="false"
  [hasTitle]="false"
  [isNewModel]="true"
  (close)="close()"
>
  <div modal-header class="groups-model-header w-100">
    <label
      class="modal-title"
      [translatable]="{
        transKey: sidebarHeaderTitle,
        modEnum: moduleEnum
      }"
    >
      {{ sidebarHeaderTitle | translate }}
    </label>
  </div>

  <div modal-content class="groups-model-content border-top">
    <div class="new-model-dialog-body">
      <form [formGroup]="form">
        <div class="form-group">
          <app-filed
            formControlName="reason"
            [control]="form | getControl : 'reason'"
            [title]="'shared.reason' | translate"
            [isRequired]="isRequired"
            [labelTranslationKey]="'shared.reason'"
            [labelTranslationModuleEnum]="translationModulesEnum.shared"
            [placeholder]="'shared.reasonPlaceholder' | translate"
            [placeholderTranslationKey]="'shared.reasonPlaceholder'"
            [placeholderTranslationModuleEnum]="translationModulesEnum.shared"
            [title]="reasonLabel | translate"
            [isRequired]="isRequired"
            [labelTranslationKey]="reasonLabelTranslationKey"
            [labelTranslationModuleEnum]="moduleEnum"
            [placeholder]="reasonPlaceholder | translate"
            [placeholderTranslationKey]="reasonPlaceholderTranslationKey"
            [placeholderTranslationModuleEnum]="moduleEnum"
            [length]="200"
          ></app-filed>
        </div>
      </form>
    </div>

    <div class="new-model-dialog-footer">
      <span
        class="w-100"
        [translatable]="{
          transKey: 'shared.back',
          modEnum: translationModulesEnum.shared
        }"
      >
        <!-- back button -->
        <button class="btn btn-dark flex-grow-1 w-100" (click)="close()">
          {{ "shared.back" | translate }}
        </button>
      </span>
      <span class="w-100">
        <!-- save button -->
        <button
          class="btn btn-main w-100 flex-grow-1 w-100"
          [disabled]="form?.invalid || isBtnLoading"
          (click)="onSubmit()"
        >
          <i class="bx bx-loader-alt bx-spin ml-1" *ngIf="isBtnLoading"></i>
          {{ "shared.save" | translate }}
        </button>
      </span>
    </div>
  </div>
</app-model>
